import React from "react";
import { motion } from "framer-motion";

const SubmitButton = ({ onClick, children }) => (
  <motion.button
    type="submit"
    className="w-full bg-[#228b22] text-white py-2 rounded-md font-body"
    whileHover={{ y: 5 }}
    onClick={onClick}
  >
    {children}
  </motion.button>
);

export default SubmitButton;
